import React from "react";

const DateFormat = ({ dateIsoString }) => {
  const date = new Date(dateIsoString); // Assumes 'props.date' is a valid date format

  // Options for `toLocaleDateString` to show full month name
  const options = { year: "numeric", month: "long", day: "numeric" };

  return <p>{date.toLocaleDateString(undefined, options)}</p>;
};

export default DateFormat;
